import { render, staticRenderFns } from "./ReferredRequests.vue?vue&type=template&id=4ec34736&scoped=true&"
import script from "./ReferredRequests.vue?vue&type=script&lang=js&"
export * from "./ReferredRequests.vue?vue&type=script&lang=js&"
import style0 from "./ReferredRequests.vue?vue&type=style&index=0&id=4ec34736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec34736",
  null
  
)

export default component.exports